"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.shared.yes': 'Sí',
    'step.shared.no': 'No',
};
